import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import style from './BusinessInform.module.css';
import HeadSub from '../../../../components/comm/HeadSub';

//Accordion
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { handlePhoneCall } from '../../../../constants/webViewBridge';

const BusinessInform = () => {
    //Accordion
    const [expanded, setExpanded] = React.useState('panel0');

    const acHandleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    // 병원 데이터
    const businessList = [
        {
            name: '가톨릭중앙의료원',
            bizName: '가톨릭대학교 가톨릭중앙의료원',
            bizNum: '114-82-02128',
            ceo: '민창기',
            addr: '서울시 서초구 반포대로222 가톨릭대학교 가톨릭중앙의료원',
            phone: '1588-1511',
        },
        {
            name: '서울성모병원',
            bizName: '가톨릭대학교 서울성모병원',
            bizNum: '114-82-00213',
            ceo: '이지열',
            addr: '서울시 서초구 반포대로 222 가톨릭대학교 서울성모병원',
            phone: '1588-1511',
        },
        {
            name: '여의도 성모병원',
            bizName: '가톨릭대학교 여의도성모병원',
            bizNum: '116-82-02162',
            ceo: '강원경',
            addr: '서울시 영등포구 63로 10 가톨릭대학교 여의도성모병원',
            phone: '1661-7575',
        },
        {
            name: '은평 성모병원',
            bizName: '가톨릭대학교 은평성모병원',
            bizNum: '205-82-02540',
            ceo: '배시현',
            addr: '서울시 은평구 통일로 1021 가톨릭대학교 은평성모병원',
            phone: '1811-7755',
        },
        {
            name: '의정부 성모병원',
            bizName: '(학)가톨릭학원의정부성모병원',
            bizNum: '127-82-00198',
            ceo: '이태규',
            addr: '경기도 의정부시 천보로 271 가톨릭대학교 의정부성모병원',
            phone: '1661-7500',
        },
        {
            name: '부천 성모병원',
            bizName: '(학)가톨릭대학교부천성모병원',
            bizNum: '130-82-02173',
            ceo: '박익성',
            addr: '경기도 부천시 원미구 소사로327 가톨릭대학교 부천성모병원',
            phone: '1577-0675',
        },
        {
            name: '인천 성모병원',
            bizName: '학교법인가톨릭학원 가톨릭대학교 인천성모병원',
            bizNum: '122-82-00887',
            ceo: '홍승모',
            addr: '인천광역시 부평구 동수로 56 가톨릭대학교 인천성모병원',
            phone: '1544-9004',
        },
        {
            name: '대전 성모병원',
            bizName: '(학)가톨릭학원가톨릭대학교대전성모병원',
            bizNum: '305-82-00236',
            ceo: '강전용',
            addr: '대전광역시 중구 대흥로 64(대흥동) 가톨릭대학교 대전성모병원',
            phone: '1577-0888',
        },
    ];

    return (
        <>
            <HeadSub title="사업자 정보" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-top-padding="sm">
                    <div className={style['mid-box']}>
                        <div className="accordion-wrap" data-type="c">
                            <div className={style['content-box']}>

                                {businessList.map((biz, index) => (
                                    <Accordion
                                        key={index}
                                        expanded={expanded === `panel${index}`}
                                        onChange={acHandleChange(`panel${index}`)}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`panel${index}-content`}
                                            id={`panel${index}-header`}
                                        >
                                            <div className="accordion-head">
                                                <p className="tit">{biz.name}</p>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="accordion-body">
                                                <div className={style['accordion-cont-box']}>
                                                    <div className={style['list-box']} data-list-type="c">
                                                        <ul>
                                                            <li>
                                                                <p>사업자명</p>
                                                                <span>{biz.bizName}</span>
                                                            </li>
                                                            <li>
                                                                <p>대표자</p>
                                                                <span>{biz.ceo}</span>
                                                            </li>
                                                            <li>
                                                                <p>사업자 등록번호</p>
                                                                <span>{biz.bizNum}</span>
                                                            </li>
                                                            <li>
                                                                <p>사업장 주소</p>
                                                                <span>{biz.addr}</span>
                                                            </li>
                                                            <li>
                                                                <p>연락처</p>
                                                                <button
                                                                    onClick={() => handlePhoneCall(biz.phone)}
                                                                >
                                                                    <span>{biz.phone}</span>
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                              </div>  
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BusinessInform;
